const palette = {
  main: "#3f97fb",
  white: "#ffffff",
  lightMain: "#9fcbfd",
  bg: "#f2f2f2",
  subText: "#767676",
  lightGray: "#c4c4c4",
  btnDisabled: "#ffc7a7",
  border: "#dbdbdb",
  waring: "#EB5757",
  kakao: "#F2C94C",
  google: "#767676",
  black: "#000000",
};

const theme = {
  palette,
};

export default theme;
